// extracted by mini-css-extract-plugin
export default {"container":"vR","productarea":"wR","btn":"xR","promowrapper":"yR","upsellarea":"zR","subtitle":"AR","system":"BR","desc":"CR","cardswrap":"ER","cards":"FR","squareloadingcontainer":"GR","squareloading33":"HR"};
    if(module.hot) {
      // 1711717534320
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  